import React from 'react';
import PdfBenchMarks from './PdfBenchmarks';

export default function BenchmarkQuartiles({ fundData }) {
  const aiProvidedData = fundData?.fund_data_in_json?.['ai-provided-data']?.[0];

  return (
    <div className="fund-wrap-content m-2 mt-2 p-3">
      <div className="d-flex justify-content-between align-items-center">
        <div className="recomandation-content">
          <PdfBenchMarks fundData={aiProvidedData} />
        </div>
      </div>
    </div>
  );
}
